import { render, staticRenderFns } from "./CompareListPlaceholder.vue?vue&type=template&id=5339508d"
import script from "./CompareListPlaceholder.vue?vue&type=script&lang=js"
export * from "./CompareListPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports